export default __webpack_public_path__ + "static/media/guide0102_m.4d9770a1.jpg";